import { useEmailQAStore } from '@/stores/email-qa'
import { Button } from '@/components/ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Filter, X } from 'lucide-react'

export function QAFilters() {
  const {
    filterStatus,
    filterRating,
    filterReviewer,
    setFilterStatus,
    setFilterRating,
    setFilterReviewer,
    clearFilters
  } = useEmailQAStore()

  const hasActiveFilters = filterStatus || filterRating || filterReviewer

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2 text-lg">
            <Filter className="h-4 w-4" />
            Filter
          </CardTitle>
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              onClick={clearFilters}
              className="text-xs"
            >
              <X className="h-3 w-3 mr-1" />
              Zurücksetzen
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {/* Status Filter */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-muted-foreground">
              Status
            </label>
            <Select
              value={filterStatus || 'all'}
              onValueChange={(value) => setFilterStatus(value === 'all' ? null : value)}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alle Status</SelectItem>
                <SelectItem value="pending">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                    Ausstehend
                  </span>
                </SelectItem>
                <SelectItem value="reviewed">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                    Bewertet
                  </span>
                </SelectItem>
                <SelectItem value="approved">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    Genehmigt
                  </span>
                </SelectItem>
                <SelectItem value="needs_improvement">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-red-500"></div>
                    Verbesserung nötig
                  </span>
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Rating Filter */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-muted-foreground">
              Bewertung
            </label>
            <Select
              value={filterRating || 'all'}
              onValueChange={(value) => setFilterRating(value === 'all' ? null : value)}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alle Bewertungen</SelectItem>
                <SelectItem value="high">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-green-500"></div>
                    Hoch (8-10)
                  </span>
                </SelectItem>
                <SelectItem value="medium">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                    Mittel (5-7)
                  </span>
                </SelectItem>
                <SelectItem value="low">
                  <span className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-red-500"></div>
                    Niedrig (1-4)
                  </span>
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Reviewer Filter */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-muted-foreground">
              Reviewer
            </label>
            <Select
              value={filterReviewer || 'all'}
              onValueChange={(value) => setFilterReviewer(value === 'all' ? null : value)}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alle Reviewer</SelectItem>
                <SelectItem value="Bernhard">Bernhard</SelectItem>
                <SelectItem value="Thomas">Thomas</SelectItem>
                <SelectItem value="Christoph">Christoph</SelectItem>
                <SelectItem value="Stefan">Stefan</SelectItem>
                <SelectItem value="Mathias">Mathias</SelectItem>
                <SelectItem value="Admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        {/* Active Filters Display */}
        {hasActiveFilters && (
          <div className="mt-4 pt-4 border-t">
            <div className="flex flex-wrap gap-2">
              <span className="text-sm text-muted-foreground">Aktive Filter:</span>
              {filterStatus && (
                <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                  Status: {filterStatus}
                  <X
                    className="h-3 w-3 cursor-pointer hover:text-blue-600"
                    onClick={() => setFilterStatus(null)}
                  />
                </span>
              )}
              {filterRating && (
                <span className="inline-flex items-center gap-1 px-2 py-1 bg-yellow-100 text-yellow-800 rounded text-xs">
                  Bewertung: {filterRating}
                  <X
                    className="h-3 w-3 cursor-pointer hover:text-yellow-600"
                    onClick={() => setFilterRating(null)}
                  />
                </span>
              )}
              {filterReviewer && (
                <span className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-800 rounded text-xs">
                  Reviewer: {filterReviewer}
                  <X
                    className="h-3 w-3 cursor-pointer hover:text-green-600"
                    onClick={() => setFilterReviewer(null)}
                  />
                </span>
              )}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  )
}